<script setup>

const props = defineProps({
	album: {
		type: Object
	},
})

</script>

<template>
	<div class="p-8 lg:p-10 dark:bg-dark8 bg-lightBg8 dark:text-light lg:text-lg lg:leading-snug">
		<div class="md:flex md:gap-10">
			<div class="mb-6 md:mb-0 max-w-[240px]">
				<NuxtImg :src="album.attrs.image?.url" />
			</div>
			<div>
				<h3 class="mb-3 text-red">{{ album.attrs.artistdisplay }}</h3>
				<h5 class="mb-5 md:mb-8">{{ album.attrs.title }}</h5>
				<Button :to="album.attrs.url" target>{{ $t('album.buy') }}</Button>
			</div>
		</div>
	</div>
</template>